import {AuthExpirationActions, AuthExpirationSetAction} from './types';

export const authExpirationSet = (expiration: number): AuthExpirationSetAction => ({
  type: AuthExpirationActions.AUTH_EXPIRATION_SET,
  expiration,
});
